import { createAsyncThunk } from "@reduxjs/toolkit";
import { IAuthListResponse } from "models/Employee/employeeManagement.model";
import { ITokenModel } from "models/Login/token.model";
import { GetAuthList } from "services/employeeManagement.service";

// Auth List for Add New Agent Page
export const getAuthListsAsync = createAsyncThunk(
  "AuthList",
  async (empReq: ITokenModel): Promise<IAuthListResponse> => {
    try {
      const response = await GetAuthList(empReq);
      return response;
    } catch (error: any) {
      throw error;
    }
  }
);
